import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=6fa1de3e"
import script from "./EmailConfirm.vue?vue&type=script&lang=ts"
export * from "./EmailConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports